/* Text box using material UI */

import { TextField } from "@mui/material";
import React from "react";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import _ from 'lodash';
import { useField } from "formik";
import { at } from 'lodash';
import useMUIStyleHelper from "../UseMUIStyleHelper";

function CsplNumberField(props) {
  const { errorText, ...rest } = props;
  const [field, meta] = useField(props);
  const { t } = useTranslation("common");
  const [fieldValue, setFieldValue] =useState(); 
  const { mandatoryClasses, nonMandatoryClasses } = useMUIStyleHelper(); 

  function _renderHelperText() {
    const [touched, error] = at(meta, 'touched', 'error');
    if (touched && error) {
      return error;
    }
  }
  const blockingChar = ['!','@','#','$','%','^','&','*','(',')'];

   const blockInvalidChar = (evt) => {
     if (evt.which === 8 || evt.which === 9) {
       return;
     }
     if ((
            (evt.which < 48 || evt.which > 57) && 
            (evt.which < 96 || evt.which > 105)
          ) || blockingChar.includes(evt.key)) {
       evt.preventDefault();
     }
   }; 

  const onChange = (evt) => {
      setFieldValue(evt.target.value);
  };

  const onBlur = (evt) => {
    const val = evt.target.value || "" ;
    window.setTimeout(() => {
       field.onChange({
        target: {
          name: props.name,
          value: val,
        },
      }); 
      field.onBlur(evt);
    }, 0);
  };

  
  useEffect(() => {
    if (field.value !== fieldValue) {
      setFieldValue(field.value);
    }
    // eslint-disable-next-line
  }, [field.value]);


  useEffect(() => {
    if (field.value !== fieldValue) {
      setFieldValue(field.value);
    }
    // eslint-disable-next-line
  }, [field.value]);



  return (
    <>
    {props.required ?  <TextField
      type="number"
      error={meta.touched && meta.error && true}
      helperText={_renderHelperText()}
      {...field}
      {...rest}
      value={fieldValue}
      onBlur={onBlur}
      onChange ={onChange}
      size="small"
      variant="outlined"
      fullWidth
      label={t(props.label)}
      onKeyDown={blockInvalidChar}
      InputLabelProps={{ shrink: true }} 
      className={mandatoryClasses.root}
      inputProps={{pattern: '[0-9]*'}}
    />
    :
    <TextField
    type="number"
    error={meta.touched && meta.error && true}
    helperText={_renderHelperText()}
    {...field}
    {...rest}
    value={fieldValue}
    onBlur={onBlur}
    onChange ={onChange}
    size="small"
    variant="outlined"
    fullWidth
    label={t(props.label)}
    onKeyDown={blockInvalidChar}
    InputLabelProps={{ shrink: true }} 
    className={nonMandatoryClasses.root}
    inputProps={{pattern: '[0-9]*'}}
  />}
  </>
  );
}
export default CsplNumberField;
